import { LoggerFactory } from 'lines-logger';
export const factory = new LoggerFactory();
factory.setLogWarnings('debug');
export let logger = factory.getLogger('EVA-SDK');
export const setLogLevel = (level) => {
    factory.setLogWarnings(level);
    logger = factory.getLogger('EVA-SDK');
};
export const createLogger = (context) => {
    return factory.getLogger(context);
};
//# sourceMappingURL=eva-sdk-core-logger.js.map